module.exports = "/assets/9ca0d6fd9530e253fefbe275f6ae7dce.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/5C.png
// module id = 2184
// module chunks = 0